export enum AuditEntityTypeName {
  CounterpartyEntity = 'CounterpartyEntity',
  ContractEntity = 'ContractEntity',
  ConsumptionObjectEntity = 'ConsumptionObjectEntity',
  // String-matched with the backend's freeform v2 EntityTypeName — no compile-time link.
  // Published by resource command handlers (create/update/delete/inject/withdraw/sale/schedules).
  ResourceEntity = 'ResourceEntity',
  // «Згенерувати прогноз» — one record per request, entity id = the organization.
  Forecast = 'Forecast',
  // «Calculate Resource Volume» requested by hand for a period, entity id = the organization.
  Resource = 'Resource',
  // Published by SubmitNominationCommandHandler (Submit, real user),
  // GetOrCreateNominationAsync in UpsertNominationByForecastCommandHandler (Create, system actor —
  // a forecast change auto-drafting a nomination has no user in the loop), and
  // NominationExportService (Export, on file download); entity id = the nomination itself.
  NominationEntity = 'NominationEntity',
  // Published by SubmitRenominationCommandHandler and RenominationExportService (Export, on file
  // download); entity id = the renomination itself.
  RenominationEntity = 'RenominationEntity',
  // «Створити» on the monthly nominations tab — one record per request covering every network
  // operator the month produced, entity id = the organization. The scheduled run publishes nothing.
  MonthlyNominationEntity = 'MonthlyNominationEntity',
  // «Виставити рахунки» — one record per issued period, entity id = the organization.
  InvoiceIssuance = 'InvoiceIssuance',
}
